<!-- eslint-disable prettier/prettier -->
<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="btn-voltar-aulas"
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="12">
            <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
              <e-label id="label-tipo-aula">Tipo de aula</e-label>
              <e-autocomplete
                id="autocomplete-tipo-aula"
                :items="$constants.tiposDeAulas"
                :return-object="false"
                :error-messages="errors"
                v-model="aulaSelecionada.tipo_de_aula"
                @change="() => verificaTipoDaAula()"
                label="Selecione um tipo de aula"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row v-if="mostrarCampos">
          <v-col class="pt-0 pb-0" cols="6">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="data"
              persistent
              width="450px"
            >
              <template v-slot:activator="{ on, attrs }">
                <e-label id="label-selecione-data">Selecione uma data</e-label>
                <v-text-field
                  id="text-selecione-data"
                  v-model="aulaSelecionada.data"
                  persistent-hint
                  :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                  label="Escolha uma data"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  solo
                ></v-text-field>
              </template>

              <v-card>
                <v-container class="calendar-container">
                  <v-row>
                    <!-- Calendário -->
                    <v-col cols="12" md="12" class="d-flex justify-center">
                      <v-card class="calendar-card pa-3" elevation="2" outlined>
                        <v-date-picker
                          v-model="data"
                          full-width
                          scrollable
                          :allowed-dates="allowedDates"
                          :events="[
                            ...feriados.map((f) => f.data),
                            ...sabadosLetivos.map((s) => s.data),
                          ]"
                          :event-color="getEventColor"
                          @update:picker-date="atualizarMesVisivel"
                          color="primary"
                          header-color="primary"
                        >
                          <template v-slot:day="{ date, day }">
                            <v-badge
                              :color="getBadgeColor(date)"
                              :content="getBadgeContent(date)"
                              overlap
                              dot
                            >
                              <span :class="{ 'font-weight-bold': isToday(date) }">{{ day }}</span>
                            </v-badge>
                          </template>
                        </v-date-picker>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!-- Lista de eventos -->
                    <v-col cols="12" md="12">
                      <v-card class="events-card" elevation="2" outlined>
                        <v-card-title class="primary white--text pa-4">
                          <v-icon left color="white">mdi-calendar-month</v-icon>
                          Eventos do Mês
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-list dense class="py-0">
                          <template v-for="(evento, index) in eventosFiltradosPorMes">
                            <v-divider v-if="index > 0" :key="`divider-${index}`"></v-divider>
                            <v-list-item :key="index" class="px-4">
                              <v-list-item-icon class="mr-3">
                                <v-icon :color="evento.cor">mdi-circle-small</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="d-flex align-center">
                                  <span class="date-label mr-2">{{
                                    formatarDia(evento.data)
                                  }}</span>
                                  <span>
                                    {{ evento.descricao }}
                                    <v-chip
                                      v-if="isSabadoLetivo(evento.data) && isFeriado(evento.data)"
                                      x-small
                                      :color="evento.cor || 'orange'"
                                      class="ml-2 white--text"
                                      dark
                                    >
                                      Feriado e Sábado Letivo
                                    </v-chip>
                                    <v-chip
                                      v-else-if="isSabadoLetivo(evento.data)"
                                      x-small
                                      :color="evento.cor || 'secondary'"
                                      class="ml-2 white--text"
                                      dark
                                    >
                                      Sábado Letivo
                                    </v-chip>
                                    <v-chip
                                      v-else-if="isFeriado(evento.data)"
                                      x-small
                                      :color="evento.cor || 'red lighten-1'"
                                      class="ml-2 white--text"
                                      dark
                                    >
                                      Feriado
                                    </v-chip>
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>

                          <v-list-item v-if="eventosFiltradosPorMes.length === 0">
                            <v-list-item-content>
                              <v-list-item-title class="text-caption grey--text">
                                Nenhum evento neste mês
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(data)">OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
              <e-label id="label-horario">Selecione um horário</e-label>
              <e-autocomplete
                id="autocomplete-horario"
                :disabled="aulaSelecionada.data ? false : true"
                :items="horarios"
                :error-messages="errors"
                label="Selecione uma opção"
                :item-text="(item) => item.descricao"
                v-model="horarioSelecionado"
                return-object
                dense
              />
            </ValidationProvider>
            <!-- @change="() => pesquisaAulas()" -->
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <e-label id="label-dia-semana">Dia da semana</e-label>
            <v-text-field
              id="text-dia-semana"
              solo
              dense
              v-model="aulaSelecionada.dia_da_semana"
              :disabled="true"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12"> </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <h4 id="header-direitos-aprendizagem">Direitos de aprendizagem</h4>
            <v-row class="">
              <v-col
                class="pt-0 pb-0"
                cols="4"
                v-for="(el, index) of opcoesAprendizagem"
                :key="index"
              >
                <v-checkbox
                  :id="`checkbox-aprendizagem-${index}`"
                  v-model="campos_de_aprendizagem[index]"
                  :label="el"
                  :value="el"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12"> </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <h4 id="header-campos-experiencias">Campos de experiencias</h4>
            <v-row class="">
              <v-col class="pt-0 pb-0" cols="4" v-for="(el, index) of opcoes" :key="index">
                <v-checkbox
                  :id="`checkbox-experiencias-${index}`"
                  v-model="campos_de_experiencias[index]"
                  :label="el"
                  :value="el"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="12"
            v-if="horarioSelecionado || aulaSelecionada.tipo_de_aula === 'Aula Remota' || editing"
          >
            <ValidationProvider
              name="Objetivos de Aprendizagem e Desenvolvimento"
              rules="required"
              v-slot="{ errors }"
            >
              <e-label id="label-objetivos-aprendizagem"
                >OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO</e-label
              >
              <v-textarea
                id="textarea-objetivos-aprendizagem"
                solo
                dense
                v-model="aulaSelecionada.objetivos_aprendizagem_desenvolvimento"
                :error-messages="errors"
              />
            </ValidationProvider>

            <ValidationProvider name="Objeto de Estudo" rules="required" v-slot="{ errors }">
              <e-label id="label-objeto-estudo">OBJETO DE ESTUDO</e-label>
              <v-textarea
                id="textarea-objeto-estudo"
                solo
                dense
                v-model="aulaSelecionada.objeto_estudo"
                :error-messages="errors"
              />
            </ValidationProvider>

            <div>
              <h3 id="header-estrategias-acoes">ESTRATÉGIAS E AÇÕES / PRÁTICAS PEDAGÓGICAS</h3>

              <ValidationProvider name="Acolhida" rules="required" v-slot="{ errors }">
                <e-label id="label-acolhida">ACOLHIDA:</e-label>
                <v-textarea
                  id="textarea-acolhida"
                  solo
                  dense
                  v-model="aulaSelecionada.acolhida"
                  :error-messages="errors"
                />
              </ValidationProvider>

              <ValidationProvider name="Atividades" rules="required" v-slot="{ errors }">
                <e-label id="label-atividades">ATIVIDADES:</e-label>
                <v-textarea
                  id="textarea-atividades"
                  solo
                  dense
                  v-model="aulaSelecionada.atividade_classe"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </div>

            <ValidationProvider name="Recursos" rules="required" v-slot="{ errors }">
              <e-label id="label-recursos">RECURSOS</e-label>
              <v-textarea
                id="textarea-recursos"
                solo
                dense
                v-model="aulaSelecionada.recursos"
                :error-messages="errors"
              />
            </ValidationProvider>

            <ValidationProvider name="Avaliação" rules="required" v-slot="{ errors }">
              <e-label id="label-avaliacao">AVALIAÇÃO</e-label>
              <v-textarea
                id="textarea-avaliacao"
                solo
                dense
                v-model="aulaSelecionada.avaliacao"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>

          <v-col cols="12" sm="4" md="3" class="py-1">
            <v-btn
              v-if="aulaSelecionada.data && horarioSelecionado"
              id="btn-enviar-dados"
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              block
              large
              class="text-capitalize"
              :class="{'mb-2': $vuetify.breakpoint.xsOnly}"
              >
              <v-icon left>mdi-send-check</v-icon>
              <span>Enviar Dados</span>
              </v-btn
            >
          </v-col>
          <v-col cols="12" sm="4" md="3" class="py-1">
            <v-btn
              id="btn-duplicar-aula"
              v-if="editing"
              class="text-capitalize sm:ml-2"
              color="primary white--text"
              @click="dialog.duplicar = true"
              block
              large
              dark
              :class="{'mb-2': $vuetify.breakpoint.xsOnly}"

              >
              <v-icon left>mdi-content-copy</v-icon>
              <span>Duplicar Aula</span>
              </v-btn
            >
          </v-col>
          <v-col cols="12" sm="4" md="3" class="py-1">
            <v-btn
              id="btn-exportar-aula"
              v-if="editing"
              class="text-capitalize sm:ml-2"
              color="primary white--text"
              @click="dialog.exportar = true"
              block
              large
              dark
              >
              <v-icon left>mdi-export</v-icon>
              <span>Exportar</span>
              </v-btn
            >
          </v-col>
        </v-row>

        <v-row v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data || !horarioSelecionado">
          <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
            <v-alert type="warning" border="left">
              Por favor, preencha os campos obrigatórios!
            </v-alert>
          </v-col>
        </v-row>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma.franquia.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario.descricao }}
                  </td>
                  <td>{{ item.turma.descricao }}</td>
                  <td>{{ item.disciplina.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <e-modal-duplicar-aula-infantil
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :horarios="horarios"
      @dialogChange="dialog.duplicar = $event"
      :datasPermitidas="datasPermitidas"
    >
    </e-modal-duplicar-aula-infantil>
    <e-modal-exportar-aula-infantil
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
    >
    </e-modal-exportar-aula-infantil>
  </main-template>
</template>

<script>
import EModalDuplicarAulaInfantil from "../../components/Aulas/EModalDuplicarAulaInfantil.vue";
import EModalExportarAulaInfantil from "../../components/Aulas/EModalExportarAulaInfantil.vue";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel, EModalDuplicarAulaInfantil, EModalExportarAulaInfantil },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    eventosFiltradosPorMes() {
      if (!this.mesVisivel) return [];

      const todosEventos = [
        ...this.feriados.map((f) => ({ ...f, tipo: "feriado" })),
        ...this.sabadosLetivos.map((s) => ({ ...s, tipo: "sabado" })),
      ];

      return todosEventos
        .filter((evento) => evento.data.startsWith(this.mesVisivel))
        .sort((a, b) => {
          return parseInt(a.data.split("-")[2]) - parseInt(b.data.split("-")[2]);
        });
    },
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
    this.carregarFeriados();
  },
  data() {
    return {
      opcoesAprendizagem: ["Conviver", "Brincar", "Participar", "Explorar", "Expressar-se"],
      opcoes: [
        "O eu, o outro e o nós",
        "Corpo, gestos e movimentos",
        "Escuta, fala, pensamento e imaginação",
        "Traços, sons, formas e imagens",
        "Espaço, tempo, quantidades, relações e transformações",
      ],
      data: null,
      dataOriginalDaAula: null,
      modal: false,
      menu: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      diasSemana: this.$constants.diasDaSemana,
      mostrarCampos: true,
      outrosCampos: false,
      submittingForm: false,
      form: {},
      campos_de_aprendizagem: [],
      campos_de_experiencias: [],
      aulaSelecionada: {
        data: null,
        dia_da_semana: "",
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      feriados: [],
      sabadosLetivos: [],
      mesVisivel: null,
      datasPermitidas: [],
    };
  },
  watch: {
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
      }
    },
    data(value) {
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");
      this.diaDaSemana();
      this.filtrarHorariosPorDiaDaSemana(new Date(value).getDay());
    },
  },
  methods: {
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      if (!this.gestaoDeAula.relacoesDiasHorarios) return;

      let horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);

      const dataAtual = this.data;

      const dataSelecionada = this.data;
      const dataOriginal = this.dataOriginalDaAula;

      if (
        this.horarioSelecionado &&
        !horariosDoDia.some((h) => h.id === this.horarioSelecionado.id) &&
        dataSelecionada === dataOriginal
      ) {
        horariosDoDia.push(this.horarioSelecionado);
      }

      if (diaDaSemana === 5) {
        horariosDoDia = this.horariosSabado;
      }

      this.horarios = horariosDoDia;
    },
    async pesquisaAulas() {
      const data_aula = this.aulaSelecionada.data;
      /* eslint-disable */
      const aula_id = this.$route.params.aula_id;
      const horario_id = this.horarioSelecionado.id;
      const turma_id = this.gestaoDeAula.turma.id;
      if (!data_aula || !this.horarioSelecionado || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
        data_aula,
        horario_id,
        turma_id,
        aula_id
      );

      if (response.data.length <= 0) {
        this.mostrarCampos = true;
        this.outrosCampos = true;
      }

      if (response.data.length > 0) {
        this.aulasEmConflitos = true;
        this.outrosCampos = false;
        this.aulasConflitadas = response.data;
      }
    },
    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      this.mostrarCampos = true;
      this.outrosCampos = false;
    },

    async submitForm() {
      this.aulaSelecionada.e_aula_infantil = 1;
      this.aulaSelecionada.campos_de_experiencias = this.campos_de_experiencias;
      this.aulaSelecionada.campos_de_aprendizagem = this.campos_de_aprendizagem;
      this.aulaSelecionada.horario_inicial = this.horarioSelecionado
        ? this.horarioSelecionado.inicio
        : null;
      this.aulaSelecionada.horario_final = this.horarioSelecionado
        ? this.horarioSelecionado.final
        : null;
      this.aulaSelecionada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;

      this.submittingForm = true;
      try {
        if (this.editing) {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.atualizar(this.aulaSelecionada);
          this.$toast.success("Aula editada com sucesso!");
        } else {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.disciplina_id = this.gestaoDeAula.disciplina_id;
          this.aulaSelecionada.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
          this.aulaSelecionada.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.criarAula(this.aulaSelecionada);
          this.$toast.success("Aula cadastrada com sucesso!");
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
      this.$router.push({
        name: "aulas",
      });
    },
    async getAula() {
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );
      this.gestaoDeAula = response.payload.gestaoDeAula;

      const turnoIdTurma = this.gestaoDeAula.turma?.turno_id;
      this.horariosSabado = response.payload.horarios.filter((h) => h.turno_id === turnoIdTurma);

      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));
      this.horarioSelecionado = aulaSelecionada.horario ?? null;
      this.campos_de_experiencias = aulaSelecionada.campos_de_experiencias
        ? aulaSelecionada.campos_de_experiencias
        : [];
      this.campos_de_aprendizagem = aulaSelecionada.campos_de_aprendizagem
        ? aulaSelecionada.campos_de_aprendizagem
        : [];
      this.datasPermitidas = response.payload.gestaoDeAula.relacoesDiasHorarios.map(
        (g) => g.dia.id
      );

      this.data = aulaSelecionada.data;
      this.dataOriginalDaAula = aulaSelecionada.data;

      const diaSemana = new Date(this.dataOriginalDaAula).getDay();
      this.filtrarHorariosPorDiaDaSemana(diaSemana);
      if (this.gestaoDeAula.relacoesDiasHorarios) {
        this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
          (g) => g.dia.id
        );

        this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
      }
      return aulaSelecionada;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        this.aulaSelecionada = await this.getAula();
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    diaDaSemana() {
      var data_do_usuario = this.aulaSelecionada.data;
      var data_do_usuario_formatada = data_do_usuario.replace(/\//g, "-");
      var array1 = data_do_usuario_formatada.split("-");
      var array2 = array1.reverse();
      var data_final = new Date(array2[0], parseInt(array2[1], 10) - 1, array2[2]);
      var dia = this.diasSemana[data_final.getDay()];
      this.aulaSelecionada.dia_da_semana = dia;
    },
    async getHorarios() {
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );
      this.gestaoDeAula = response.payload.gestaoDeAula;

      // Filtrar horariosSabado com base no turno_id da turma
      const turnoIdTurma = this.gestaoDeAula.turma?.turno_id;
      this.horariosSabado = response.payload.horarios.filter((h) => h.turno_id === turnoIdTurma);

      if (this.gestaoDeAula.relacoesDiasHorarios) {
        this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
          (g) => g.dia.id
        );

        this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
      }
      this.horariosDoComponente =
        new Date(this.data).getDay() === 5 ? this.horariosSabado : this.horarios;
    },
    allowedDates(val) {
      const dataFormatada = new Date(val).toISOString().split("T")[0];

      const diaDaSemana = new Date(val).getDay();

      if (diaDaSemana === 5) {
        const ehSabadoLetivo = this.sabadosLetivos.some(
          (sabado) => new Date(sabado.data).toISOString().split("T")[0] === dataFormatada
        );
        return ehSabadoLetivo;
      }

      const ehFeriado = this.feriados.some(
        (feriado) => new Date(feriado.data).toISOString().split("T")[0] === dataFormatada
      );

      const ehDiaPermitido = this.diasPermitidosParaCriarAula.includes(diaDaSemana);

      return ehDiaPermitido && !ehFeriado;
    },
    async carregarFeriados() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();

        this.feriados = response
          .filter((evento) => evento.evento.is_feriado === true)
          .map((evento) => ({
            data: evento.start,
            descricao: evento.descricao,
            cor: evento.color,
          }));

        this.sabadosLetivos = response
          .filter((evento) => evento.evento.is_sabado_letivo === true)
          .map((evento) => ({
            data: evento.start,
            descricao: evento.descricao,
            cor: evento.color,
          }));
      } catch (error) {
        console.error("Erro ao carregar feriados:", error);
      }
    },

    atualizarMesVisivel(pickerDate) {
      const [ano, mes] = pickerDate.split("-");
      this.mesVisivel = `${ano}-${mes}`;
    },

    formatarDia(data) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}`;
    },
    isFeriado(date) {
      return this.feriados.some((f) => f.data === date);
    },

    isSabadoLetivo(date) {
      return this.sabadosLetivos.some((s) => s.data === date);
    },

    getBadgeColor(date) {
      if (this.isFeriado(date)) return "red";
      if (this.isSabadoLetivo(date)) return this.getEventColor(date);
      return "";
    },

    getBadgeContent(date) {
      if (this.isFeriado(date)) return "F";
      if (this.isSabadoLetivo(date)) return "S";
      return "";
    },

    getEventColor(date) {
      const cores = [];

      const feriado = this.feriados.find((f) => f.data === date);
      if (feriado) cores.push(feriado.cor);

      const sabado = this.sabadosLetivos.find((s) => s.data === date);
      if (sabado) cores.push(sabado.cor);

      return cores.length > 0 ? cores : "red";
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}
</style>
